import { gsap } from "gsap";

import { EventsManager, GameEvents } from "../../../abstracts/events/EventsManager";
import { AbstractView } from "../../../abstracts/modules/AbstractView";
import { playSound, stopSound } from "../../../abstracts/utils/SoundUtils";
import { UgliestCatch } from "../../UgliestCatch";
import { UCSoundNames } from "../../assetsLoader/UCAssetsNames";

export class UCUserInterfaceView extends AbstractView {
    private isIdleActive: boolean = true;
    private repeatTween: gsap.core.Tween;
    private idleTimeline: gsap.core.Timeline;

    // private mainSpine: AbstractSpine;
    // private enabledIcon: Icon;
    // private disabledIcon: Icon;

    constructor() {
        super(`UCUserInterfaceView`);
    }

    // protected isMobile(): boolean {
    //     return NolimitApplication.apiPlugin.options.device === Device.MOBILE;
    // }

    protected initGraphics() {
        super.initGraphics();
        this.position.set(360, 360);
    }

    public onXBetBtnClick(isToggled: boolean): void {
        this.disableIdle();

        if (isToggled) {
            // this.onXbetButtonToggled();
            EventsManager.trigger(GameEvents.SHOW_XBET_FRAME);

            playSound({ name: UCSoundNames.XBET_ON });
            stopSound({ name: UCSoundNames.XBET_OFF });
        } else {
            this.turnOffXBet();

            playSound({ name: UCSoundNames.XBET_OFF });
            stopSound({ name: UCSoundNames.XBET_ON });
        }
    }

    private turnOffXBet(isFreeBets: boolean = false): void {
        // this.disabledIcon.addChild(this.mainSpine);
        // this.mainSpine.reset();
        // this.mainSpine.getSpineTween(`xbet_disabled_idle`, true);

        // UgliestCatch.model.isXbet = false;
        // SlotGame.apiPlugin.betHandler.setBoost(undefined);
        EventsManager.trigger(GameEvents.HIDE_XBET_FRAME);

        this.isIdleActive = true;

        if (!isFreeBets) {
            this.repeatTween = gsap.delayedCall(
                3 + Math.random() * 3,
                this.onIdleRepeat.bind(this)
            );
        } else {
            this.repeatTween?.kill();
        }
    }

    // private onXbetButtonToggled(): void {
    // this.enabledIcon.addChild(this.mainSpine);
    // this.mainSpine.reset();
    // this.mainSpine.getSpineTween(`xbet_enabled_click`, false, null, null, () => {
    //     this.mainSpine.getSpineTween(`xbet_enabled_loop`, true);
    // });
    // const featureData = SlotGame.apiPlugin.bonusFeatures.getFeatureDataByName(boostedName);
    // const boostedData = { featureName: boostedName, price: featureData!.price };
    // SlotGame.apiPlugin.betHandler.setBoost(boostedData);
    //
    // UgliestCatch.model.isXbet = true;
    // }

    public onFreeBets() {
        // this.xBetBtn.toggled = false;
        this.turnOffXBet(true);
    }

    private onIdleRepeat() {
        if (this.isIdleActive) {
            const onTweenComplete = () => {
                if (this.isIdleActive) {
                    this.repeatTween = gsap.delayedCall(18, this.onIdleRepeat.bind(this));
                }
                // this.xBetContainer.alpha = 0;

                // this.removeChild(this.xBetContainer);

                // this.checkXbetPosition();
            };

            this.idleTimeline = gsap.timeline({ paused: true, onComplete: onTweenComplete });

            if (!UgliestCatch.apiPlugin.freeBets.hasFreeBets()) {
                // const showXBetContainerAnimation = gsap.to(this.xBetContainer, {
                //     duration: 0.2,
                //     alpha: 1,
                //     onStart: () => {
                //         this.addChild(this.xBetContainer);
                //         this.xBetContainer.alpha = 0;
                //     },
                // });
                // this.idleTimeline.add(showXBetContainerAnimation);
                // const hideXBetContainerAnimation = gsap.to(this.xBetContainer, {
                //     duration: 0.1,
                //     alpha: 0,
                //     delay: 5,
                // });
                //
                // this.idleTimeline.add(hideXBetContainerAnimation);
            }

            this.idleTimeline.resume();
        }
    }

    public enableIdle(isToggled: boolean) {
        if (isToggled) {
            this.isIdleActive = true;
            this.repeatTween = gsap.delayedCall(0, this.onIdleRepeat.bind(this));
        }
    }

    public disableIdle() {
        // this.removeChild(this.xBetContainer);
        // this.xBetContainer.alpha = 0;
        this.isIdleActive = false;
        this.repeatTween?.kill();
        this.idleTimeline?.kill();
    }

    // public handleRestore() {
    // this.xBetBtn.toggled = true;
    // this.onXbetButtonToggled();
    // }

    /*private checkXbetPosition(): void {
        const bounds: ScreenBounds = NolimitApplication.screenBounds;

        if (this.xBetBtn) {
            if (NolimitApplication.isLandscape) {
                if (this.isMobile()) {
                    this.xBetBtn.position.set(bounds.width / 2 - 60, 0);
                } else {
                    this.xBetBtn.position.set(530, 0);
                }
            } else {
                this.xBetBtn.position.set(200, bounds.height / 2 - 130);
            }
        }

        if (this.xBetContainer) {
            if (NolimitApplication.isLandscape) {
                this.xBetContainer.scale.set(1);
                if (this.isMobile()) {
                    this.xBetContainer.position.set(this.xBetBtn.x - 64, this.xBetBtn.y - 176);
                } else {
                    this.xBetContainer.position.set(476, -172);
                }
            } else {
                this.xBetContainer.scale.set(0.7);
                this.xBetContainer.position.set(this.xBetBtn.x - 17, bounds.height / 2 - 276);
            }
        }
    }*/

    public onResize(): void {
        // this.checkXbetPosition();
    }
}
